import { ActionType } from 'types/shared';
import { FlightsActionType, FlightsShoppingPwaFlightSearchResultsFlightsSearch } from '__generated__/api';
import ForcedChoiceCrossSellDialog = FlightsShoppingPwaFlightSearchResultsFlightsSearch.FlightsForcedChoiceCrossSellDialogInlineFragment;

export const getGoToPackagesAction = (forcedChoiceCrossSellDialog: ForcedChoiceCrossSellDialog) => {
  const { actions } = forcedChoiceCrossSellDialog;

  return actions?.find(action => action.type === FlightsActionType.GO_TO_PACKAGES) as ActionType;
};

export const decodeEncodePackageAbleUrl = (
  forcedChoiceCrossSellDialog: ForcedChoiceCrossSellDialog,
  initialPackageUriRelativePath: string
) => {
  const { checkInDate, checkOutDate } = forcedChoiceCrossSellDialog;

  if (checkInDate?.date && checkOutDate?.date) {
    const actionType = getGoToPackagesAction(forcedChoiceCrossSellDialog);
    let decodedUrl =
      (initialPackageUriRelativePath || actionType?.relativePackageableURI?.relativePath) &&
      decodeURIComponent(initialPackageUriRelativePath || actionType.relativePackageableURI.relativePath);

    decodedUrl =
      decodedUrl &&
      decodedUrl
        .replace('${checkInDate}', checkInDate.date.isoFormat)
        .replace('${checkOutDate}', checkOutDate.date.isoFormat)
        .replace('${toDate}', checkOutDate.date.isoFormat);

    actionType.relativePackageableURI = { relativePath: decodedUrl && encodeURI(decodedUrl), value: null };

    return actionType.relativePackageableURI.relativePath;
  }
};
